import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import FireTruckIcon from "@mui/icons-material/FireTruck";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
//import Tonghopvantai from "views/Tonghopvantai/Tonghopvantai.js";
import Phuluc5 from "views/Tonghopvantai/Phuluc5.js";
import Phuluc6 from "views/Tonghopvantai/Phuluc6.js";
import Phuluchangkhong from "views/Tonghopvantai/Phuluchangkhong.js";
import Phulucduongsat from "views/Tonghopvantai/Phulucduongsat.js";
//import Tonghopduongthuy from "views/Duongthuy/Tonghopduongthuy.js";
import Hanhkhachtonghopthuy from "views/Duongthuy/Hanhkhachtonghop.js";
import Hanghoatonghopthuy from "views/Duongthuy/Hanghoatonghop.js";
import Cangbientonghop from "views/Duongthuy/Cangbientonghop.js";
import AirlineSeatReclineNormalIcon from "@mui/icons-material/AirlineSeatReclineNormal";
//import Tonghopduongsat from "views/Duongsat/Tonghopduongsat.js";
import Hanhkhachtonghopsat from "views/Duongsat/Hanhkhachtonghop.js";
import Hanghoatonghopsat from "views/Duongsat/Hanghoatonghop.js";
//import Tonghopduonghangkhong from "views/Duonghangkhong/Tonghopduonghangkhong.js";
import Hanhkhachtonghophangkhong from "views/Duonghangkhong/Hanhkhachtonghop.js";
import Hanghoatonghophangkhong from "views/Duonghangkhong/Hanghoatonghop.js";
import Hanhkhachduongbotonghop from "views/Duongbotonghop/Hanhkhachtonghop.js";
import Hanghoaduongbotonghop from "views/Duongbotonghop/Hanghoatonghop.js";

const routevantaikhac = [
  {
    path: "/tonghopvantai",
    name: "Báo cáo tổng hợp",
    rtlName: "قائمة الجدول",
    icon: AppRegistrationIcon,
    layout: "/admin",
    sub: 1,
    id: 1,
  },
  {
    path: "/phuluc5",
    name: "Phụ lục 5",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Phuluc5,
    layout: "/admin",
    parent: 1,
  },
  {
    path: "/phuluc6",
    name: "Phụ lục 6",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Phuluc6,
    layout: "/admin",
    parent: 1,
  },
  {
    path: "/phuluchangkhong",
    name: "Phụ lục 10",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Phuluchangkhong,
    layout: "/admin",
    parent: 1,
  },
  {
    path: "/phulucduongsat",
    name: "Phụ lục 11",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Phulucduongsat,
    layout: "/admin",
    parent: 1,
  },
  {
    path: "/hanhkhachduongbotonghop",
    name: "Vận tải HK đường bộ",
    rtlName: "قائمة الجدول",
    icon: AirlineSeatReclineNormalIcon,
    component: Hanhkhachduongbotonghop,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/hanghoaduongbotonghop",
    name: "Vận tải HH đường bộ",
    rtlName: "قائمة الجدول",
    icon: FireTruckIcon,
    component: Hanghoaduongbotonghop,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/hanhkhachduongthuy",
    name: "Vận tải HK đường thủy",
    rtlName: "قائمة الجدول",
    icon: AirlineSeatReclineNormalIcon,
    component: Hanhkhachtonghopthuy,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/hanghoaduongthuy",
    name: "Vận tải HH đường thủy",
    rtlName: "قائمة الجدول",
    icon: FireTruckIcon,
    component: Hanghoatonghopthuy,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/cangbientonghop",
    name: "Sản lượng HH qua cảng",
    rtlName: "قائمة الجدول",
    icon: ProductionQuantityLimitsIcon,
    component: Cangbientonghop,
    layout: "/admin",
    sub: 0,
  },
  /*{
    path: "/tonghopduongsat",
    name: "Tổng hợp đường sắt",
    rtlName: "قائمة الجدول",
    icon: AppRegistrationIcon,
    component: Tonghopduongsat,
    layout: "/admin",
    sub: 0,
  },*/
  {
    path: "/hanhkhachduongsat",
    name: "Vận tải HK đường sắt",
    rtlName: "قائمة الجدول",
    icon: AirlineSeatReclineNormalIcon,
    component: Hanhkhachtonghopsat,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/hanghoaduongsat",
    name: "Vận tải HH đường sắt",
    rtlName: "قائمة الجدول",
    icon: FireTruckIcon,
    component: Hanghoatonghopsat,
    layout: "/admin",
    sub: 0,
  },
  /*{
    path: "/tonghopduonghangkhong",
    name: "Tổng hợp đường hàng không",
    rtlName: "قائمة الجدول",
    icon: AppRegistrationIcon,
    component: Tonghopduonghangkhong,
    layout: "/admin",
    sub: 0,
  },*/
  {
    path: "/hanhkhachduonghangkhong",
    name: "Vận tải HK hàng không",
    rtlName: "قائمة الجدول",
    icon: AirlineSeatReclineNormalIcon,
    component: Hanhkhachtonghophangkhong,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/hanghoaduonghangkhong",
    name: "Vận tải HH hàng không",
    rtlName: "قائمة الجدول",
    icon: FireTruckIcon,
    component: Hanghoatonghophangkhong,
    layout: "/admin",
    sub: 0,
  },
];

export default routevantaikhac;
